/**
 * AUTO-GENERATED — do not edit by hand.
 *
 * Source: package.json
 * Generator: scripts/sync-version.mjs
 *
 * Run `npm run sync-version` (or any script that depends on it) to refresh
 * after bumping the package version.
 */

export const VERSION = '4.8.0' as const;
